import { demandConstants } from "./types";
import { addFeedback, getMyDemand, askToAgent,getMemberFek, getMemberIban} from "../../../services/workflow.service";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";
import { extractApiErrorMessage, getApiBusinessErrorMessage } from "../../../utilities/apiErrorMessage";

const endError = error => {
  return dispatch => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: demandConstants.DEMANDS_ERROR,
        error,
      });
    }
  };
};

const addFeedbacks = (konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, phone) => {
  return dispatch => {
    dispatch(request("addFeedbacks"));
    return addFeedback(konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, phone).then(
      feedback => {
        const businessError = getApiBusinessErrorMessage(feedback);

        if (businessError) {
          dispatch({
            type: demandConstants.DEMANDS_ERROR,
            error: feedback,
            message: businessError,
          });
          return { success: false, message: businessError };
        }

        dispatch(success(feedback));
        return { success: true };
      },
      error => {
        dispatch(loading.hideLoading());
        if (error?.response?.status === 401 || error?.message === "Network Error") {
          dispatch(beginLogout());
          return { success: false };
        }

        const message = extractApiErrorMessage(error);

        dispatch({
          type: demandConstants.DEMANDS_ERROR,
          error,
          message,
        });

        return {
          success: false,
          message,
        };
      }
    );
  };
  function request(feedback) {
    return {
      type: demandConstants.ADD_FEEDBACK_REQUEST,
      payload: { feedback }
    };
  }
  function success(feedback) {
    return {
      type: demandConstants.ADD_FEEDBACK_SUCCESS,
      payload: { feedback }
    };
  }
};

const askToAgents = (konu, aciklama) => {
  return dispatch => {
    dispatch(request("askToAgents"));
    return askToAgent(konu, aciklama).then(
      feedback => {
        dispatch(success(feedback));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request(agent) {
    return {
      type: demandConstants.ASK_TO_AGENT_REQUEST,
      payload: { agent }
    };
  }
  function success(agent) {
    return {
      type: demandConstants.ASK_TO_AGENT_SUCCESS,
      payload: { agent }
    };
  }
};

const clearSuccessMessage = () => {
  return {
    type: demandConstants.CLEAR_SUCCESS_MESSAGE,
    payload: {  }
  };
};

const getMyDemands = () => {
  return dispatch => {
    dispatch(request());
    getMyDemand().then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: demandConstants.GET_MY_DEMANDS_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: demandConstants.GET_MY_DEMANDS_SUCCESS,
      payload: { list: data }
    };
  }
};
const getMemberFeks = (basvuruNedeni) => {
  return dispatch => {
    dispatch(request());
    return getMemberFek(basvuruNedeni).then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };

  function request() {
    return { type: demandConstants.GET_MEMBER_FEK_REQUEST };
  }
  function success(data) {
    return { type: demandConstants.GET_MEMBER_FEK_SUCCESS, payload: { memberFek: data } };
  }
};

const getMemberIbans = () => {
  return dispatch => {
    dispatch(request());
    return getMemberIban().then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };

  function request() {
    return { type: demandConstants.GET_MEMBER_IBAN_REQUEST };
  }
  function success(data) {
    return { type: demandConstants.GET_MEMBER_IBAN_SUCCESS, payload: { memberIban: data } };
  }
};

const clearMemberFek = () => {
  return {
    type: demandConstants.CLEAR_MEMBER_FEK,
    payload: []
  };
};

const clearMemberIban = () => {
  return {
    type: demandConstants.CLEAR_MEMBER_IBAN,
    payload: []
  };
};

export { addFeedbacks, getMyDemands, askToAgents, clearSuccessMessage, getMemberFeks , clearMemberFek, getMemberIbans, clearMemberIban};
